import { render, staticRenderFns } from "./DisableToChange.vue?vue&type=template&id=183cfd96&scoped=true&"
import script from "./DisableToChange.vue?vue&type=script&lang=ts&"
export * from "./DisableToChange.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183cfd96",
  null
  
)

export default component.exports